import { WidgetKind } from 'corso-admin-ui';
import { rateReport } from '../orderItems';

export const rate = rateReport({
  finalized: { metric: 'warrantyItemsFinalized' },
  rate: {
    kind: WidgetKind.kpi,
    description: 'Of items ordered in this period, finalized so far',
    metric: 'warrantyRate',
  },
  chart: {
    title: 'Warranty claim rate by order date',
    description:
      'By when the items were ordered; claims can come long after, so recent orders read low',
  },
  tables: {
    products: 'Product warranty rate',
    variants: 'Product variant warranty rate',
    rankedBy: 'items finalized for warranty',
  },
});
